import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';

@Component({
  selector: 'pm-poses-list',
  templateUrl: './poses-list.component.html',
  styleUrls: ['./poses-list.component.sass']
})
export class PosesListComponent {
  public pageTitle = 'POS';

  public showPoses = true;
  public showAddPos = false;
  public showEditPos = false;
  public editnumber = 0;
}
